import { gql } from '@apollo/client'

import { CONSTANT_ENTITY_FIELDS } from './constantEntities'

export const RX_SHIPMENT_FIELDS = gql`
  fragment RxShipmentFields on RxShipment {
    externalShipmentId
    trackingId
    shippedAt
    deliveredAt
  }
`

export const RX_ORDER_FIELDS = gql`
  ${RX_SHIPMENT_FIELDS}
  fragment RxOrderFields on RxOrder {
    externalOrderId
    placedAt
    rxShipments {
      ...RxShipmentFields
    }
  }
`

export const RX_USAGE_FIELDS = gql`
  ${RX_ORDER_FIELDS}
  fragment RxUsageFields on RxUsage {
    externalRxUsageId
    dispensedAmount
    rxOrder {
      ...RxOrderFields
    }
  }
`

export const PRESCRIPTION_REFILL_FIELDS = gql`
  ${CONSTANT_ENTITY_FIELDS}
  fragment PrescriptionRefillFields on Prescription {
    id
    businessId
    name
    type
    createdAt
    updatedAt
    totalQuantity
    totalQuantityUnit {
      ...ConstantEntityFields
    }
    drugExpirationDate
    refillExpirationDate
    state {
      ...ConstantEntityFields
    }
    origin
    rxType
    deleted
    notes
    orderNumber
    partNumber
    globalVariationMapping {
      id
      chewyItems {
        count
        partNumber
      }
    }
  }
`

export const PRESCRIPTION_FIELDS = gql`
  ${CONSTANT_ENTITY_FIELDS}
  fragment PrescriptionFields on Prescription {
    id
    businessId
    name
    categoryId
    client {
      id
    }
    patient {
      id
    }
    doctorId
    rxNo
    type
    administrationQuantity
    administrationQuantityUnit {
      ...ConstantEntityFields
    }
    administrationQuantityCustomUnit
    administrationFrequency {
      ...ConstantEntityFields
    }
    administrationFrequencyNotes
    administrationCourseType
    administrationCourseLength
    administrationRoute {
      ...ConstantEntityFields
    }
    drugExpirationDate
    prescribedDate
    globalInventoryId
    globalVariationId
    globalInventoryMapping {
      id
    }
    globalVariationMapping {
      id
      chewyItems {
        count
        partNumber
      }
    }
    globalFoodCatalogId
    globalFoodCatalogVariationId
    inventoryId
    numberRefills
    quantityPerRefill
    quantityPerRefillUnit {
      ...ConstantEntityFields
    }
    quantityPerRefillCustomUnit
    refillExpirationDate
    totalQuantity
    totalQuantityUnit {
      ...ConstantEntityFields
    }
    totalQuantityCustomUnit
    controlled
    deleted
    createdAt
    updatedAt
    rejectionReason
    state {
      ...ConstantEntityFields
    }
    compoundingReasonState {
      ...ConstantEntityFields
    }
    compoundingReason
    notes
    orderNumber
    partNumber
    drugInfo {
      customCompound
      customForm
      deliveryMethod {
        id
        name
      }
      description
      flavor
      form {
        ...ConstantEntityFields
      }
      masterName
      strength
      strengthColor {
        ...ConstantEntityFields
      }
      strengthUnits {
        ...ConstantEntityFields
      }
      variationName
      perPackageAmount
      perPackageUnits {
        ...ConstantEntityFields
      }
      packageType {
        ...ConstantEntityFields
      }
      count
      compounded
    }
    mismatchWarning
    pdfUrl
    rxType
    origin
    signer {
      id
      firstName
      lastName
    }
    signatureUrl
    task {
      id
    }
    soapId
    invoice {
      id
    }
  }
`
